import { render } from "./ui-loadingbox.vue?vue&type=template&id=00d372f8"
import script from "./ui-loadingbox.vue?vue&type=script&lang=js"
export * from "./ui-loadingbox.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__